import React from 'react'
import { Box, Text, IcoMoon, FreeShippingIcon } from '@usap/uicomponents'

export default function FreeShipping(props) {
  const { sku, isFreeShipping, customMargin } = props

  const margin = customMargin || { vertical: '4px' }
  return isFreeShipping ? (
    <Box
      id={`free-shipping-${sku}`}
      direction="row"
      margin={margin}
      data-testid="pdp-freeshipping-badge"
    >
      <Box margin={{ right: 'small' }} alignSelf="center">
        <IcoMoon icon={FreeShippingIcon} color="#fc7e00" size="24px" />
      </Box>
      <Box alignSelf="center">
        <Text
          color="#2e4787"
          size="small"
          weight={700}
          style={{ fontStyle: 'Italic' }}
        >
          FREE Shipping
        </Text>
      </Box>
    </Box>
  )
    : ''
}
